import { PROD_API_ORIGIN, STG_API_ORIGIN } from 'constants/apiBaseUrl'

export const isLocal = window.location.hostname.includes('localhost')

const apiOrigin =
  process.env.VITE_FIREBASE_PROJECT_ID === 'otw-stg' ? STG_API_ORIGIN : PROD_API_ORIGIN

/** Legacy callers use `/api` without the `v1` segment (axios uses `apiBaseUrl` instead). */
export const API_URL = `${apiOrigin}/api`

export const socketUrl = apiOrigin

export { auth, app, firebaseConfig } from './firebase'
